import * as React from "react";
import type { SVGProps } from "react";
const SvgDataStorage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24" {...props}
  >
    <ellipse
      cx={8.999}
      cy={9.999}
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      rx={6.003}
      ry={2.501}
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15.001 13.501c0 1.381-2.687 2.501-6.002 2.501s-6.003-1.12-6.003-2.501M21.004 10c0 1.38-2.688 2.5-6.003 2.5"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15.001 10v7.503c0 1.38-2.687 2.5-6.002 2.5s-6.003-1.12-6.003-2.5V10M21.004 6.498v7.503c0 1.382-2.688 2.501-6.003 2.501"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.5 7.508a1.44 1.44 0 0 1-.501-1.01c0-1.381 2.691-2.501 6.002-2.501s6.003 1.12 6.003 2.5C21.004 7.879 18.313 9 15.001 9c-.17 0-.34 0-.5-.01"
    />
  </svg>
);
export default SvgDataStorage;
